import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CompanyMaintenanceRoutingModule } from './company-maintenance-routing.module';
import { CompanyMaintenanceComponent } from './company-maintenance.component';
import { CompanyMaintenanceFormComponent } from './company-maintenance-form/company-maintenance-form.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';
import { MaintenanceListModule } from 'src/app/core/custom-modules/maintenance-list/maintenance-list.module';
import { MaintenanceDetailModule } from 'src/app/core/custom-modules/maintenance-detail/maintenance-detail.module';
import { CompanyMaintenanceFilterComponent } from './company-maintenance-filter/company-maintenance-filter.component';
import { CountryDropdownModule } from 'src/app/core/custom-modules/dropdowns/country-dropdown/country-dropdown.module';
import { RegionDropdownModule } from 'src/app/core/custom-modules/dropdowns/region-dropdown/region-dropdown.module';
import { ProvinceDropdownModule } from 'src/app/core/custom-modules/dropdowns/province-dropdown/province-dropdown.module';
import { CityDropdownModule } from 'src/app/core/custom-modules/dropdowns/city-dropdown/city-dropdown.module';
import { IndustryTypeDropdownModule } from 'src/app/core/custom-modules/dropdowns/industry-type-dropdown/industry-type-dropdown.module';
import { GenericDropdownModule } from 'src/app/core/custom-modules/dropdowns/generic-dropdown/generic-dropdown.module';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
    MaintenanceListModule,
    MaintenanceDetailModule,
    CompanyMaintenanceRoutingModule,
    CountryDropdownModule,
    RegionDropdownModule,
    ProvinceDropdownModule,
    CityDropdownModule,
    IndustryTypeDropdownModule,
    GenericDropdownModule
  ],
  declarations: [CompanyMaintenanceComponent, CompanyMaintenanceFormComponent, CompanyMaintenanceFilterComponent],
  entryComponents: [CompanyMaintenanceFilterComponent]
})
export class CompanyMaintenanceModule { }
